import { render, staticRenderFns } from "./ShouYe.vue?vue&type=template&id=a5a9b0ee&scoped=true"
import script from "./ShouYe.vue?vue&type=script&lang=js"
export * from "./ShouYe.vue?vue&type=script&lang=js"
import style0 from "./ShouYe.vue?vue&type=style&index=0&id=a5a9b0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a9b0ee",
  null
  
)

export default component.exports